export { default as Number } from '../Number'
export { default as Currency } from '../Currency'
export { default as Percent } from '../Percent'
export { default as Rating } from '../Rating'
export { default as Trend } from '../Trend'
export { default as Label } from '../Label'
export { default as Info } from '../Info'
export { default as Inline } from '../Inline'
export { default as Root } from '../Root'
export { default as Content } from '../Content'
export { default as Text } from '../Text'
